<script setup lang="ts">
import { PublicSellerReturnsQuery } from '@gql/PublicSellerReturnsQuery'

const t2 = useT2({
  'Return address': 'Grąžinimo adresas',
  Or: 'Arba',
  'Start online return': 'Grąžinti internetu', // simplified even more
  'To return page': 'Į grąžinimų puslapį', // made plural for better context
  'Return policies': 'Grąžinimo taisyklės',
  'Return are not accepted': 'Grąžinimai nepriimami',
  'Days for return': 'Grąžinimo terminas', // better term
  'Returns are not accepted': 'Grąžinimai nepriimami',
  return_txt: {
    en: 'You can either use our online form below or download and print our return form fill your order details',
    lt: 'Užpildykite grąžinimo formą internetu arba atsisiųskite ir atspausdinkite grąžinimo dokumentą', // more concise
  },
})

const mobile = useMobile()
const { myLink } = useLinks()
const { seller, sellerId } = useSeller('server')
const durationStr = useDurationTranslate()

const { ui } = useApolloWrap2<gen.PublicSellerReturnsQuery, gen.PublicSellerReturnsQueryVariables>(PublicSellerReturnsQuery)({
  vars() {
    const id = sellerId.value
    return id ? { sellerId: id } : undefined
  },
  ui: (i) => helpers.arr(i?.publicSellerReturns),
})

useHead({
  title: t2('Returns & Refunds'),
})
</script>

<template>
  <AppMenu :title="t2('Returns & Refunds')">
    <template #title>
      <ButtonBack :to="myLink('info-returns')" :txt="t2('Start online return')" :txt2="t2('To return page')">
        <template #icon><IconReturns /></template>
      </ButtonBack>
    </template>

    <template #content>
      <!-- <div v-if="fast" class="_pb1 _short">{{ t2('You can download return form, print it, fill your order details or fill form below') }}</div> -->
      <div class="_pb3 _short">{{ t2('return_txt') }}</div>

      <div class="_pb4 _ctrY _wrap _row m_gap2 d_gap4">
        <LinkUi black :to="myLink('info-returns-create')" :txt="t2('Start online return')" arrow big />
        <span v-if="!mobile" class="_fw-xl _fs08">{{ t2('Or') }}</span>
        <AppDownloadReturns />
      </div>
      <DocumentUi :document-id="seller?.doc?.returns?._id" />

      <div :class="seller?.doc?.returns?._id && '_pt4'">
        <h3 class="_pb2">{{ t2('Return address') }}</h3>
        <SellerReturnAddress class="_pl04" :seller-id="sellerId" />
      </div>
    </template>

    <h3 class="_pb2 _pl1 _pt2">{{ t2('Return policies') }}</h3>
    <InfoBoxes
      :items="ui"
      :ui="
        (i) => ({
          key: i.id,
          title: i.title.value,
          description: i.message.value,
          hasContent: !!i.document?._id || !!i.message.value?.length,
        })
      "
    >
      <template #txt="{ index, item }">
        <div class="_pb1">
          <em class="_fw-xl _fs09 _mono _ls-xxxs _mr04">{{ helpers.zeroPad(index + 1, 2) }}.</em>
          <span class="_fs1 _fw-xl _txt">{{ item.title.value }}</span>
        </div>
        <UiLine v-if="item.returnsNotAllowed" :label="undefined" :value="t2('Return are not accepted')" col />
        <UiLine v-else col :label="t2('Days for return')" :value="item.duration" :ui="(i) => durationStr(i) ?? ''" />
      </template>

      <template #default="{ item }">
        <div v-if="item.message.value" class="_txt">{{ item.message.value }}</div>
        <DocumentUi :document-id="item.document?._id" />
      </template>
    </InfoBoxes>
  </AppMenu>
</template>
